export default function (n) {
  const result = Array(n);
  for (let i = 0; i < n; i += 1) {
    result[i] = i;
  }
  return result;
}
